module.exports = __webpack_public_path__ + "assets/img/family-1.8a3de91b.jpeg";